import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { initializeI18n } from './i18n';
import reportWebVitals from './reportWebVitals';

import * as Sentry from "@sentry/react";
import { PostHogProvider } from '@posthog/react';

const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
const posthogKey = process.env.REACT_APP_POSTHOG_TOKEN;
const posthogHost = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';
const appEnv = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: appEnv,
    release: process.env.REACT_APP_RELEASE || "nimos-frontend-dev",
  });
}

const i18n = initializeI18n();

// The crash fallback sits outside the normal provider; bind this same instance.
function AppErrorFallback() {
  const { t } = useTranslation("translation", { i18n });
  return <p>{t("appFeedback.unexpectedError")}</p>;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const app = (
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

root.render(
  posthogKey ? (
    <PostHogProvider
      apiKey={posthogKey}
      options={{
        api_host: posthogHost,
        defaults: '2026-01-30',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true,
      }}
    >
      {app}
    </PostHogProvider>
  ) : (
    app
  )
);

reportWebVitals();
